(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var form = document.getElementById('product-form');
    if (!form) return;
    var jsonEl = document.getElementById('product-variants-json');
    var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    var hiddenId = form.querySelector('input[name="id"]');
    var optionInputs = form.querySelectorAll('[data-option-input]');
    if (variants.length <= 1 || !hiddenId) return;
    function getSelectedOptions() {
      var opts = [];
      optionInputs.forEach(function(input) {
        if (input.checked) opts.push(input.value);
      });
      return opts;
    }
    function findVariant() {
      var selected = getSelectedOptions();
      return variants.find(function(v) {
        return v.options && v.options.length === selected.length && v.options.every(function(opt, i) { return opt === selected[i]; });
      });
    }
    optionInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        var v = findVariant();
        if (v) hiddenId.value = v.id;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
